import SmallCalendar from './SmallCalendar';

export default SmallCalendar;
